/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const QuestionIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    onClick={props.onClick}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <g id="question-icon">
      <path d="M23.5,10.883 C23.5,16.064 18.352,20.265 12,20.265 C10.582,20.265 9.225,20.056 7.971,19.673 L1.363,22.749 L3.951,17.583 C1.821,15.88 0.501,13.507 0.501,10.883 C0.5,5.7 5.648,1.5 12,1.5 C18.352,1.5 23.5,5.7 23.5,10.883 Z" />
      <path d="M13,15.5 C13,15.776 12.776,16 12.5,16 C12.224,16 12,15.776 12,15.5 C12,15.224 12.224,15 12.5,15 C12.776,15 13,15.224 13,15.5 Z" />
      <path d="M9.5,8.5 C9.5,6.843 10.843,5.5 12.5,5.5 C14.157,5.5 15.5,6.843 15.5,8.5 C15.5,10.157 14.157,11.5 12.5,11.5 L12.5,13" />
    </g>
  </svg>
);

export default QuestionIcon;
